module.exports = __webpack_public_path__ + "static/media/9_l_cvetok_0_54.63.1feb99d1.png";